import React, {memo} from 'react';
import PropTypes from 'prop-types';
import {Skeleton} from 'antd';
import classNames from 'classnames';


const HeroPlaceholder = ({className}) => {
  return (
    <div className={classNames('text-center flex flex-col items-center mt-8 mb-10 lg:mt-16 lg:mb-20', className)}>
      <Skeleton.Input active className={'mb-3 w-full max-w-160'}/>
      <Skeleton className={'skeleton-center'} active paragraph={{rows: 4}} title={false}/>
      <Skeleton.Button active size={'large'} shape={'round'} className={'mt-4 w-32'}/>
      <Skeleton.Button active size={'small'} shape={'round'} className={'mt-1 mb-4 w-16 skeleton-thin'}/>
    </div>
  );
};

const ImagesPlaceholder = ({className}) => {
  return (
    <div className={classNames('flex flex-row justify-center -mt-8 flex-wrap mb-10 lg:mb-20', className)}>
      <Skeleton.Button active size={'small'} shape={'round'} className={'w-full max-w-56 h-90 mx-4 mt-8'}/>
      <Skeleton.Button active size={'small'} shape={'round'} className={'w-full max-w-56 h-90 mx-4 mt-8'}/>
      <Skeleton.Button active size={'small'} shape={'round'} className={'w-full max-w-56 h-90 mx-4 mt-8'}/>
      <Skeleton.Button active size={'small'} shape={'round'} className={'w-full max-w-56 h-90 mx-4 mt-8'}/>
      <Skeleton.Button active size={'small'} shape={'round'} className={'w-full max-w-56 h-90 mx-4 mt-8'}/>
    </div>
  );
};

const ImageWithTextPlaceholder = ({className, right}) => {
  return (
    <div className={classNames('flex flex-col lg:flex-row mt-8 mb-10 lg:mt-16 lg:mb-20', className)}>

      <div className={classNames('w-full max-w-90', {'order-2 lg:pl-12': right}, {'lg:pr-12': !right})}>
        <Skeleton.Image
          className={classNames('w-full h-64')}/>
      </div>

      <div className={classNames('flex flex-col flex-grow mt-4', {'order-1': right})}>
        <Skeleton.Input active className={'mb-3 w-full max-w-64'}/>
        <Skeleton active paragraph={{rows: 4}} title={false}/>
        <Skeleton.Button active size={'large'} shape={'round'} className={'mt-2 w-24'}/>
      </div>

    </div>
  );
};

const PageLoading = () => {

  return (
    <div className={'page-wrapper '}>
      <HeroPlaceholder/>
      <ImageWithTextPlaceholder className={'lg:mt-32'}/>
      <ImageWithTextPlaceholder className={'lg:mt-32'} right/>
      <ImagesPlaceholder />
    </div>
  );

};

export default memo(PageLoading);

HeroPlaceholder.propTypes = {
  className: PropTypes.string
};

ImageWithTextPlaceholder.propTypes = {
  className: PropTypes.string,
  right: PropTypes.bool
};

ImagesPlaceholder.propTypes = {
  className: PropTypes.string
};
